import React, { useState } from 'react';
import Hero from '../components/home/Hero';
import FeaturedListings from '../components/home/FeaturedListings';
import WhatsAppButton from '../components/common/WhatsAppButton';
import PropertyDetailPage from './PropertyDetailPage';
import { getImage } from '../services/ImageService';

const HomePage = () => {
    const [selectedProperty, setSelectedProperty] = useState(null);
    const featuredProperties = [
        {
            id: 1,
            title: 'Prestige Pine Forest',
            description: 'Luxurious 3-bedroom apartment with stunning city views',
            price: 'Starting at 3.9 CR.',
            image: getImage('1.1')
        },
        {
            id: 2,
            title: 'NVT  OIKOS',
            description: 'Beautiful 4-bedroom villa with private pool',
            price: 'Starting at 6.5 CR.',
            image: getImage('2.1')
        },
        {
            id: 3,
            title: 'Prestige Raintree Park',
            description: 'Luxurious 3-bedroom apartment with stunning city views',
            price: 'Starting at 2.95Cr',
            image: getImage('3.1')
        }
    ];

    const handleSelectProperty = (property) => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        setSelectedProperty(property);
    };

    if (selectedProperty) {
        return (
            <div className="home-page">
                <button className="back-button" onClick={() => setSelectedProperty(null)}>
                    ← Back to Home
                </button>
                <PropertyDetailPage property={selectedProperty} />
            </div>
        );
    }

    return (
        <>
            <Hero />
            <FeaturedListings properties={featuredProperties} onSelect={handleSelectProperty} />
            <WhatsAppButton />
        </>
    );
};

export default HomePage;